// Moved from Confluence Cloud repo:
// https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence/browse/confluence-plugins/confluence-editor-plugins/confluence-editor/src/main/resources/tinymce3/plugins/table/atlassian-table.js
import rteTable from './aeTable-rteTable';
import window from 'window-or-global';
import { isDarkFeatureEnabled } from '../utils/dark-features-query-selector';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

const setup = (ed) => {
	/**
	 * Customisations to tinymce table plugin.
	 */

	function isHighlightRemoval() {
		return !!$('#table-highlight-group').attr('data-remove-highlight');
	}

	function isDefaultColour() {
		return !rteTable.getSelectedHighlightColour();
	}

	function setBackgroundColour(cells) {
		let colour;
		clearBackgroundColour(cells);
		if (!isDefaultColour()) {
			colour = rteTable.getSelectedHighlightColour();
			cells.attr('data-highlight-colour', colour);
			cells.addClass(`highlight-${colour}`);
		}
	}

	function clearBackgroundColour(cells) {
		let i;
		let l;
		let cell;
		for (i = 0, l = cells.length; i < l; i++) {
			cell = cells.eq(i);
			if (cell.attr('data-highlight-colour')) {
				cell.removeAttr('data-highlight-colour');
			}
			/**
			 * CONFDEV-37873
			 * somehow, there are many CSS class "highlight-" on a cell
			 * should remove all of them, not only the one stored in "data-highlight-colour"
			 */
			cell[0].className = cell[0].className.replace(/( |^)highlight(-\w+)+/g, '');
		}
	}

	function tableCustomisations() {
		const getSelectedRow = function (editor) {
			let selectedCells = $(editor.getBody()).find('td.mceSelected,th.mceSelected');
			if (!selectedCells.length) {
				selectedCells = $(editor.selection.getNode());
			}
			let row = selectedCells.closest('tr');
			let parent = row.parent();
			let table = parent.is('tbody') ? row.parent().parent() : parent;

			while (row.length !== 0 && !table.is('.confluenceTable')) {
				row = table.closest('tr');
				parent = row.parent();
				table = parent.is('tbody') ? row.parent().parent() : parent;
			}

			return row;
		};

		const getSelectedCell = function (editor) {
			return $(editor.selection.getNode()).closest('th.confluenceTh,td.confluenceTd');
		};

		const getSelectedCells = function (editor) {
			const selectedCells = $(editor.getBody()).find(
				'th.confluenceTh.mceSelected,td.confluenceTd.mceSelected',
			);
			if (selectedCells.length) {
				return selectedCells;
			}

			// Return the cell based on the cursor position
			return getSelectedCell(editor);
		};

		const isTableAllHeadings = function (table) {
			return table.find('tbody > tr > td').length === 0;
		};

		/**
		 * Toggle row highlighting favours highlighting, so
		 * if one or more cells are not highlighted, then highlight.
		 * <p>
		 * "highlight" is used for td's.
		 * "nohighlight" is used for th's (to support existing content).
		 */
		ed.addCommand('confTableRowToggleHeading', function () {
			//button && button.toggleClass("selected");
			const row = getSelectedRow(this);
			let rowCells = row.children('td,th');
			let columnIdx = 0;

			if (rteTable.areCellsHeadings(rowCells)) {
				// all cells highlighted - remove highlighting unless heading column
				if (!isTableAllHeadings(row.closest('table'))) {
					rowCells = rowCells.filter(function () {
						const cell = $(this);
						const table = cell.closest('table');
						columnIdx += cell.attr('colspan') || 1;
						// exclude cells that form a column heading
						return !rteTable.isColumnHeading(table, columnIdx);
					});
				}
				rteTable.convertToNormalCells(ed, rowCells);
			} else {
				// not all cells are highlighted - ensure all are highlighted
				rteTable.convertToHeadingCells(ed, rowCells);
			}
		});
		/**
		 * Toggle column highlighting favours highlighting, so
		 * if one or more cells are not highlighted, then highlight.
		 * <p>
		 * Highlighting is not removed from the heading cell (th) if
		 * the heading row if highlighted.
		 * <p>
		 * "highlight" is used for td's.
		 * "nohighlight" is used for th's (to support existing content).
		 */
		ed.addCommand('confTableColumnToggleHeading', function () {
			function getColumnCells(selectedCells) {
				let cells = $([]);
				selectedCells.each(function () {
					const selectedCell = $(this);
					const index = selectedCell.index() + 1; //nth-child is 1-indexed
					const table = selectedCell.closest('table.confluenceTable');
					const rows = table.children('tbody').children('tr');
					cells = cells.add(rows.children().nthCol(index));
				});
				return cells;
			}

			const selectedCells = getSelectedCells(this);
			let columnCells = getColumnCells(selectedCells);

			// removes columnCells where an entire row is a heading
			if (rteTable.areCellsHeadings(columnCells)) {
				// all cells highlighted unless there's a row of th
				if (!isTableAllHeadings(columnCells.closest('table'))) {
					columnCells = columnCells.filter(function () {
						const cell = $(this);
						const row = cell.parent('tr');
						const siblingCells = row.children();
						const siblingThCells = siblingCells.filter('th');
						return siblingCells.length !== siblingThCells.length;
					});
				}
				rteTable.convertToNormalCells(ed, columnCells);
			} else {
				// not all cells are highlighted - ensure all are highlighted
				rteTable.convertToHeadingCells(ed, columnCells);
			}
		});

		/**
		 * Highlights the current table cell selection, or if none the current cell.
		 */
		ed.addCommand('confTableSelectionToggleHighlight', function (ui, options) {
			const alwaysHighlight = options && options.alwaysHighlight;
			const selectedCells = getSelectedCells(this);

			if (
				(rteTable.areCellsHighlighted(selectedCells) && !alwaysHighlight) ||
				isHighlightRemoval()
			) {
				clearBackgroundColour(selectedCells);
			} else {
				setBackgroundColour(selectedCells);
			}
		});

		if (window.tinymce.isIE8 || isDarkFeatureEnabled('confluence-table-enhancements.auto-row')) {
			ed.on('KeyDown', function (e) {
				function isEdgeElement(element, cell, direction) {
					while (element != cell) {
						if (element[direction]) {
							return false;
						}

						element = element.parentNode;
					}

					return true;
				}

				function isCaretAtEdgeOfCell(cell, direction) {
					const rng = ed.selection.getRng(true);
					const sc = rng.startContainer;
					if (rng.collapsed) {
						const edgeElement = isEdgeElement(sc, cell, direction);
						if (sc.nodeType === 3) {
							return edgeElement && rng.startOffset == (direction == 'nextSibling' ? sc.length : 0);
						} else if (sc == cell) {
							// sc.childNodes.length - 1 because a <br> tag is included in empty table cells by default
							return rng.startOffset == (direction == 'nextSibling' ? sc.childNodes.length - 1 : 0);
						} else {
							return edgeElement;
						}
					}

					return false;
				}

				// If we're in the first cell of the table, we need to let the normal event proceed and move the cursor
				// out of the table
				function isCaretInFirstCell() {
					const selectedNode = ed.selection.getNode();
					const $table = $(selectedNode).parents('table').first();
					const firstCell = $table.find('tr:first-child').children().first()[0];

					return firstCell == selectedNode;
				}

				// Similarly if we're in the last cell of the table
				function isCaretInLastCell() {
					const selectedNode = ed.selection.getNode();
					const $table = $(selectedNode).parents('table').first();
					const lastCell = $table.find('tr:last-child').children().last()[0];

					return lastCell == selectedNode;
				}

				if ((e.keyCode === 37 || e.keyCode === 39) && !e.shiftKey) {
					const $selectedCell = getSelectedCell(this);
					if ($selectedCell.length) {
						const selectedCell = $selectedCell[0];
						if (
							e.keyCode === 37 &&
							isCaretAtEdgeOfCell(selectedCell, 'previousSibling') &&
							!isCaretInFirstCell()
						) {
							ed.execCommand('mceTableMoveCaretToPrevCell');
							return window.tinymce.dom.Event.cancel(e);
						} else if (
							e.keyCode === 39 &&
							isCaretAtEdgeOfCell(selectedCell, 'nextSibling') &&
							!isCaretInLastCell()
						) {
							ed.execCommand('mceTableMoveCaretToNextCell');
							return window.tinymce.dom.Event.cancel(e);
						}
					}
				}
			});
		}

		function isInTable(node) {
			return $(node).parents('table').is('.confluenceTable');
		}

		function isNearestParentList(node) {
			// Determine which tag is closest out of UL, OL and TR
			const parentTag = ed.dom.getParent(node, 'UL,OL,TR').tagName;
			return parentTag === 'UL' || parentTag === 'OL';
		}

		// Handle tabbing in a table.
		function addRowOnPressingTab(e) {
			if (e.keyCode === 9) {
				const node = ed.selection.getNode();
				if (isInTable(node) && !isNearestParentList(node)) {
					const command = e.shiftKey
						? 'mceTableMoveCaretToPrevCell'
						: 'mceTableMoveCaretToNextCell';
					ed.execCommand(command);
					e.preventDefault();
					return false;
				}
			}
		}

		ed.on('KeyDown', (e) => {
			addRowOnPressingTab(e);
		});

		if (isDarkFeatureEnabled('confluence-table-enhancements.auto-row')) {
			// If the numbering column is clicked, move the cursor to the next cell
			ed.on('Click', function () {
				const $selectedCell = getSelectedCell(this);

				if ($selectedCell.hasClass('numberingColumn') && !$selectedCell.hasClass('confluenceTh')) {
					ed.execCommand('mceTableMoveCaretToNextCell');
				}
			});

			// We need to handle moving down or up from the first cell of a heading row
			ed.on(
				'KeyDown',
				function (e) {
					if ((e.keyCode === 38 || e.keyCode === 40) && isInTable()) {
						if (getSelectedCell(this).hasClass('numberingColumn')) {
							ed.execCommand('mceTableMoveCaretToNextCell');
							e.preventDefault();
							return false;
						}
					}
				},
				true,
			);
		}
	}

	function setNumberingColumnUneditable() {
		const $editorContent = $(window.tinymce.activeEditor.getBody());
		const numberingColumnCells = $editorContent.find('.confluenceTd.numberingColumn');

		numberingColumnCells.attr('contenteditable', 'false');
	}

	ed.on('init', tableCustomisations);

	// On editor init, we need to prevent the numbering column from being editable
	if (isDarkFeatureEnabled('confluence-table-enhancements.auto-row')) {
		// init.rte is fired too early in the quickedit process, so bind to both events
		//AJS.bind('quickedit.success', setNumberingColumnUneditable);
		//AJS.bind('init.rte', setNumberingColumnUneditable);
		ed.on('init', setNumberingColumnUneditable);
	}
};

export default { setup };
